import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { ProjectPhase, InvestmentType, DataSet } from 'src/app/interfaces/investmentcontrolling/inco-project';

@Component({
  selector: 'history-project-dialog',
  templateUrl: './history-project-dialog.component.html',
  styleUrls: ['./history-project-dialog.component.less'],
  standalone: false
})
export class HistoryProjectDialogComponent implements OnInit {
  public dataSource = new MatTableDataSource<any>();
  columnsToDisplay: string[] = [];
  label: string = '';
  projectPhases: ProjectPhase[] = [];
  investmentTypes: InvestmentType[] = [];
  multiprojects: DataSet[] = [];

  constructor(
    private dialogRef: MatDialogRef<HistoryProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.columnsToDisplay = [
      'projectTitle',
      'responsibleUser',
      'multiproject',
      'investmentType',
      'researchDevelopment',
      'manufacturing',
      'fieldOperations',
      'informationTechnology',
      'bigR',
      'maintenance',
      'expansion',
      'focus',
      'phaseId',
      'updatedBy',
      'updatedAtUtc'
    ];
    this.label = this.data?.id || '';
    this.dataSource.data = this.data?.history || [];
    this.investmentTypes = this.data.investmentTypes;
    this.projectPhases = this.data.projectPhases;
    this.multiprojects = this.data.multiprojects;
  }

  getPhaseLabel(phaseId: number | undefined): string {
    const phase = this.projectPhases.find(p => p.id === phaseId);
    return phase ? `${phase.phaseName}` : `${phaseId}`;
  }

  getInvestmentTypeLabel(investmentTypeId: number | undefined): string {
    const investmentType = this.investmentTypes.find(it => it.id === investmentTypeId);
    return investmentType ? `${investmentType.investmentName}` : '';
  }


  getMultiprojectLabel(multiprojectId: number | undefined): string {
    const multiproject = this.multiprojects.find(mp => mp.id === multiprojectId);
    return multiproject ? `${multiproject.name}` : '';
  }

  close() {
    this.dialogRef.close();
  }
}

@NgModule({
  declarations: [
    HistoryProjectDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule
  ]
})
export class HistoryProjectDialogModule { }
